// Webpack Imports
import 'bootstrap';
import 'slick-slider';
import Lottie from 'lottie-web';
import React from 'react';
import '@lottiefiles/lottie-player';
import {
  create
} from '@lottiefiles/lottie-interactivity';
(function($) {
  'use strict';

  // JQuery fallback: add title attribute from placeholder
  $('input, textarea').attr('title', function() {
    return $(this).attr('placeholder');
  });

  // Focus Search if Searchform is empty
  $('.search-form').on('submit', function(e) {
    var search = $('#s');
    if (search.val().length < 1) {
      e.preventDefault();
      search.focus();
    }
  });

  //custom
  $("div[data-slick]").slick();
/*  $(".region").each(function(index) {
    $(this).find('.region-contests').slick({
      nextArrow: $(this).children().find('.region-next-arrow'),
      prevArrow: $(this).children().find('.region-prev-arrow'),
      slide: "region-element"
    });
  });
*/

  function getPosition(element) {
    var xPosition1 = 0;
    var yPosition1 = 0;
    var xPosition2 = 0;
    var yPosition2 = 0;

    while (element) {
      xPosition1 += (element.offsetLeft - element.scrollLeft + element.clientLeft);
      yPosition1 += (element.offsetTop - element.scrollTop + element.clientTop);
      xPosition2 += (element.offsetLeft - element.scrollLeft + element.clientLeft);
      yPosition2 += (element.offsetTop - element.scrollTop + element.clientTop);
      element = element.offsetParent;
    }

    return {
      x1: xPosition1,
      y1: yPosition1,
      x2: xPosition2,
      x2: xPosition2,
    };
  }

  const logoAnimData = {
    container: document.getElementById('navbar-brand'),
    path: '/wp-content/themes/ideen4kaernten-theme/assets/json/Logo.json',
    renderer: 'svg',
    loop: !1,
    autoplay: !1,
    name: "animScroll",
  };
  var animScroll, tl;


  var logoAnimScroll = bodymovin.loadAnimation(logoAnimData);
  var logoAnimDirection = 1;


  const mapAnimData = {
    container: document.getElementById('map_animation'),
    path: '/wp-content/themes/ideen4kaernten-theme/assets/json/Map.json',
    renderer: 'svg',
    loop: !1,
    autoplay: !1,
    name: "animMap",
  };
  var animScroll, tl;


  const mapAnim = bodymovin.loadAnimation(mapAnimData);

  document.addEventListener('scroll', function(event) {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      $("#header").addClass("scrolled");
      logoAnimScroll.setDirection(logoAnimDirection);
      logoAnimScroll.play();
    } else {
      $("#header").removeClass("scrolled");
      logoAnimScroll.setDirection(-logoAnimDirection);
      logoAnimScroll.play();
    }
  }, true /*Capture event*/ );

  $(window).resize(function() {});

  for (var x = 0; x < $('.animated-list-items').children().find(".number").length; x++) {
    $('.animated-list-items').children().find(".number").eq(x).addClass("hidden");
  }

  function refreshScrollPoints() {
    var scrollPoints = [];
    for (var index = 0; index < $('.animated-list-items > li').length; index++) {
      var listItemPosY = getPosition($('.animated-list-items').find('li')[index]).y1;
      scrollPoints.push(listItemPosY);
    }
    return scrollPoints;
  }

  function splitIntoRanges(max, nInt, add) {
    const c = Math.floor(max / nInt);
    const r = [];
    for (var i = 0; i <= max; i += c) {
      const a = i == 0 ? i : i += 1;
      const b = i + c > max ? max : i + c;
      if (a < max) r.push([a + add, b + add])
    }
    return r;
  }


  function isBetween(n, a, b) {
    return (n - a) * (n - b) <= 0
  }

  var lastScrollTop = 0;
  var lastScrollRange = 0;
  var lastD = 0;
  var listDistance = 0;
  var playing = [];

  function updateMapAnimation(scrollTop)
  {
    var scrollPoints = refreshScrollPoints();
    var minScroll = scrollPoints[0];
    var maxScroll = scrollPoints[scrollPoints.length-1];
    var minAnimation = 0;
    var maxAnimation = 75;
    var minScrollRange = 0;
    var maxScrollRange = maxScroll - minScroll;
    var scrollInRange = scrollTop - minScroll;
    var scrollPercent = scrollInRange / maxScrollRange;
    var relativeFrame = maxAnimation * scrollPercent;
    var relativeFrameFloor = Math.floor(relativeFrame);
    if(scrollTop > minScroll && scrollTop < maxScroll){
    mapAnim.playSegments([relativeFrameFloor,relativeFrameFloor+1], true);
    }
    console.log(scrollPercent, relativeFrameFloor);
  }




  document.addEventListener('scroll', function(event) {
    var scrollPoints = refreshScrollPoints();
    var ranges = splitIntoRanges(scrollPoints[scrollPoints.length - 1] - scrollPoints[0], scrollPoints.length, scrollPoints[0]);
    playing.length = scrollPoints.length;

    var frameRanges = [
      [0, 10],
      [11, 20],
      [21, 30],
      [31, 75]
    ];

    var st = $(window).scrollTop();
    var ph = $(window).height();
    var hph = ph / 2;
    var trig = hph + st;
    updateMapAnimation(trig);
    var d = 1;

    if (st > lastScrollTop) {
      d = 1;
    }
    if (st < lastScrollTop) {
      d = -1;
    } else {
      d = 1;
    }
    lastScrollTop = st;

    for (var i = 0; i < ranges.length; i++) {
      var humanIndex = i + 1;
      if (!isBetween(trig, ranges[i][0], ranges[i][1])) {
        lastScrollRange = -1;
      } else if (isBetween(trig, ranges[i][0], ranges[i][1])) {
        if (i != lastScrollRange) {
          if (d > 0) {
            //down
            if (playing[i] == null || playing[i] < 0) {
              /*mapAnim.playSegments([frameRanges[i][0], frameRanges[i][1]], false);
              playing[i] = 1;
              console.log(playing);*/
            }
          } else if (d < 0) {
            //up
            if (playing[i] == null || playing[i] < 0) {
              /*mapAnim.playSegments([frameRanges[i][1], frameRanges[i][0]], false);
              playing[i] = -1;
              console.log(playing);*/
            }
          }

          if (trig > scrollPoints[0]) {
            listDistance = scrollPoints[i] - scrollPoints[0];
            $("body").get(0).style.setProperty('--verticalLineHeight', listDistance + 'px');
            console.log(listDistance);
          }
          if (trig > scrollPoints[scrollPoints.length - 1]) {
            listDistance = scrollPoints[scrollPoints.length - 1] - scrollPoints[0];
            $("body").get(0).style.setProperty('--verticalLineHeight', listDistance + 'px');
            console.log(listDistance);
          }
          lastScrollRange = i;
        }
        if (d < 0) {
          listDistance = scrollPoints[i] - scrollPoints[0];
          $("body").get(0).style.setProperty('--verticalLineHeight', listDistance + 'px');
          $('.animated-list-items').children().find(".number").eq(i).addClass("hidden");
        }
        if (d > 0) {
          listDistance = scrollPoints[i] - scrollPoints[0];
          $("body").get(0).style.setProperty('--verticalLineHeight', listDistance + 'px');
          $('.animated-list-items').children().find(".number").eq(i).removeClass("hidden");
        }
      }
    }
  }, true);
}(jQuery));
